import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withTranslation } from '@ifit/rapport-webview';
import rapportPackage from './rapport-web.json';
import I18nType from '../../../shared/i18n-prop-type';

import Locked from './locked';

const ProgramInfo = ({ workoutCount, locked, i18n }) => (
  <div className={classNames('info', { locked })}>
    {locked && <Locked />}
    <div>
      <span className="count">
        {workoutCount === 0 ? '\u00A0' : workoutCount}
      </span>
      <span className="type">
        {workoutCount === 0
          ? '\u00A0'
          : workoutCount === 1
          ? i18n._t`Workout`
          : i18n._t`Workouts`}
      </span>
    </div>
    <div className="icon">
      <span className="card-icon">P</span>
    </div>
  </div>
);

ProgramInfo.propTypes = {
  workoutCount: PropTypes.number,
  locked: PropTypes.bool,
  i18n: I18nType,
};

ProgramInfo.defaultProps = {
  workoutCount: 0,
};

export default withTranslation(rapportPackage)(ProgramInfo);
